import { IRestriction, ICustomerRestrictionsFilters } from '../types';
import { PAYMENT_TYPES, paymentTypesLangKeys } from '~/constants/main';

export const defaultRestriction: IRestriction = {
  customer: [],
  payment_type: 0,
  comment: undefined,
};

export const defaultPagination = {
  currentPage: 0,
  lastPage: 0,
  perPage: 0,
  totalRows: 0,
};

export const defaultCustomersRestrictionsFilters: ICustomerRestrictionsFilters = {
  search: '',
};

export const paymentTypes = {
  [PAYMENT_TYPES.CASH]: paymentTypesLangKeys[PAYMENT_TYPES.CASH],
  [PAYMENT_TYPES.ONLINE_PAYMENT]: paymentTypesLangKeys[PAYMENT_TYPES.ONLINE_PAYMENT],
  [PAYMENT_TYPES.TERMINAL]: paymentTypesLangKeys[PAYMENT_TYPES.TERMINAL],
};
